import { defineStore } from 'pinia'
import { ref } from 'vue'

/**
 * 营销弹窗状态管理
 */
export const useMarketingModalStore = defineStore('marketingModal', () => {
  // 是否显示弹窗
  const isVisible = ref(false)

  const showModal = () => {
    isVisible.value = true
  }

  /**
   * 隐藏弹窗
   */
  const hideModal = () => {
    isVisible.value = false
  }

  return {
    isVisible,
    showModal,
    hideModal,
  }
})
